/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const styles = (theme) => {
    const { typography, palette, breakpoints: { maxWidth, minWidth } } = theme;
    return {
        bgsCMSWrapper: {
            '& .bgsBannerWrapper': {
                color: palette?.common.white,
                paddingTop: '50px',
                paddingBottom: '50px',
                marginRight: '-15px',
                marginLeft: '-15px',
                position: 'relative !important',
                [theme.breakpoints.down(minWidth?.small_medium_down)]: {
                    paddingTop: '30px',
                    paddingBottom: '30px',
                },
                [theme.breakpoints.down(maxWidth?.screen_ipad_pro)]: {
                    paddingTop: '0px',
                },
                '& .bgsBannerPadding': {
                    padding: '0px',
                },
                '& .desktopBanner': {
                    margin: '0 0 1rem',
                    [theme.breakpoints.down(maxWidth?.screen_ipad_pro)]: {
                        display: 'none',
                    },
                },
                '& .mobileBanner': {
                    display: 'none',
                    margin: '0 0 1rem',
                    [theme.breakpoints.down(maxWidth?.screen_ipad_pro)]: {
                        display: 'block',
                    },
                },
                '& .bannerContent': {
                    position: 'absolute',
                    top: '85px',
                    left: '160px',
                    maxWidth: '645px',
                    [theme.breakpoints.between(minWidth?.medium_screen_up, maxWidth?.medium_screen_down)]: {
                        top: '50px',
                        left: '50px',
                        maxWidth: '620px',
                    },
                    [theme.breakpoints.down(minWidth?.small_medium_down)]: {
                        top: '30px',
                        left: '30px',
                    },
                    [theme.breakpoints.down(minWidth?.small_screen_up)]: {
                        top: '10px',
                        left: '25px',
                        width: '380px',
                    },
                    [theme.breakpoints.down(maxWidth?.xs_large_screen)]: {
                        width: '300px',
                        top: '30px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        '-webkit-transform': 'translate(-50%)',
                        '-moz-transform': 'translate(-50%)',
                    },
                    [theme.breakpoints.down(maxWidth?.xxxs_screen)]: {
                        width: '280px !important',
                        top: '30px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        '-webkit-transform': 'translateX(-50%)',
                        '-moz-transform': 'translateX(-50%)',
                    },
                    '& h1': {
                        fontSize: typography.font_size_lg_bgs_title,
                        [theme.breakpoints.between(minWidth?.medium_screen_up, maxWidth?.medium_screen_down)]: {
                            fontSize: typography.font_size_lg_track_order_title,
                        },
                        [theme.breakpoints.down(maxWidth?.small_medium_down)]: {
                            fontSize: '2.125rem',
                        },
                        [theme.breakpoints.down(minWidth?.small_screen_up)]: {
                            fontSize: typography.font_size_xlg,
                            marginBottom: '0px',
                        },
                        [theme.breakpoints.down(maxWidth?.xs_large_screen)]: {
                            fontSize: typography.font_size_track_order_sub_md_title,
                            paddingBottom: '10px',
                        },
                    },
                    '& .textBlock': {
                        fontFamily: typography?.font_family_base,
                        fontWeight: typography?.font_weight_light,
                        margin: '0 auto',
                        marginTop: '15px',
                        fontSize: '0.938rem',
                        maxWidth: '560px',
                        lineHeight: '1.5',
                        [theme.breakpoints.between(minWidth?.medium_screen_up, maxWidth?.medium_screen_up)]: {
                            maxWidth: '560px',
                            fontSize: typography.font_size_md,
                        },
                        [theme.breakpoints.down(minWidth?.small_medium_down)]: {
                            marginTop: '0',
                            fontSize: typography.font_size_base,
                            lineHeight: '1.5',
                            maxWidth: '500px',
                        },
                        [theme.breakpoints.down(minWidth?.small_screen_up)]: {
                            fontSize: typography.font_size_sm,
                            lineHeight: '1.5',
                            maxWidth: '375px',
                        },
                        [theme.breakpoints.down(maxWidth?.xs_large_screen)]: {
                            fontSize: typography.font_size_base,
                            lineHeight: '1.5',
                            maxWidth: '255px',
                        },
                    },
                    '& button': {
                        fontFamily: typography.font_family_base,
                        width: '300px',
                        height: '50px',
                        background: palette?.common?.white,
                        borderRadius: '0',
                        marginTop: '25px',
                        paddingTop: '10px',
                        letterSpacing: '1.8px',
                        '&:hover': {
                            color: palette?.common?.gray_900,
                        },
                        [theme.breakpoints.between(minWidth?.small_screen_down, maxWidth?.small_medium_down)]: {
                            width: '220px',
                            height: '36px',
                            marginTop: '15px',
                            padding: '8px',
                        },
                        [theme.breakpoints.down(minWidth?.small_medium_down)]: {
                            width: '200px',
                            height: '40px',
                            padding: '10px',
                        },
                        [theme.breakpoints.down(minWidth?.small_screen_up)]: {
                            width: '200px',
                            height: '30px',
                            padding: '6px',
                            marginTop: '5px',
                        },
                        [theme.breakpoints.down(maxWidth?.xs_large_screen)]: {
                            height: '45px',
                            marginTop: '15px',
                        },
                    },
                },
                '& .background': {
                    background: palette?.bgs_banner,
                    minHeight: '392px',
                    [theme.breakpoints.between(minWidth?.xs_large_screen_surface_duo, maxWidth?.small_medium_down)]: {
                        minHeight: 'unset !important',
                    },
                    [theme.breakpoints.between(minWidth?.medium_screen_down, maxWidth?.medium_screen_down)]: {
                        minHeight: 'unset !important',
                    },
                    '@media (orientation: landscape)': {
                        minHeight: 'unset !important',
                    },
                },
                '& .banner-btn-container': {
                    position: 'absolute !important',
                    [theme.breakpoints.down(maxWidth?.screen_ipad_pro)]: {
                        alignItems: 'center !important',
                        bottom: 'unset !important',
                        justifyContent: 'center !important',
                        margin: 'unset !important',
                        right: 'unset !important',
                        textAlign: 'center !important',
                        top: '24%',
                    },
                    [theme.breakpoints.between(minWidth?.xs_large_screen_surface_duo, maxWidth?.small_medium_down)]: {
                        bottom: '17% !important',
                        right: '7.5% !important',
                        columnGap: '0.15rem !important',
                    },
                    [theme.breakpoints.between(minWidth?.small_medium_down, maxWidth?.big_screen_down)]: {
                        bottom: '19% !important',
                        right: '7.4% !important',
                        columnGap: '0.55rem !important',
                    },
                    '& .btn-control': {
                        [theme.breakpoints.between(minWidth?.surface_duo, maxWidth?.small_screen_up)]: {
                            '&.col-sm-4': {
                                flex: '0 0 33.3333% !important',
                                maxWidth: '33.3333% !important',
                            },
                        },
                        '& .btn-secondary': {
                            borderColor: '#87AA35',
                            '&:focus': {
                                boxShadow: 'unset !important',
                            },
                            [theme.breakpoints.down(maxWidth?.screen_ipad_pro)]: {
                                padding: 'unset !important',
                                height: '35px !important',
                                width: '202px !important',
                                paddingTop: '5px !important',
                            },
                            [theme.breakpoints.between(minWidth?.xs_large_screen_surface_duo, maxWidth?.small_medium_down)]: {
                                width: '103px !important',
                                height: '30px !important',
                                paddingTop: '9px !important',
                                fontSize: '0.601rem !important',
                            },
                            [theme.breakpoints.between(minWidth?.small_medium_down, maxWidth?.big_screen_down)]: {
                                width: '137 !important',
                                height: '37px !important',
                                fontSize: '0.82rem !important',
                                paddingTop: '10px !important',
                            },
                        },
                    },
                },
            },
            '& .bgsAboutWrapper': {
                paddingBottom: '50px',
                [theme.breakpoints.down(minWidth?.small_medium_down)]: {
                    paddingBottom: '30px',
                },
                [theme.breakpoints.down(minWidth?.small_screen_up)]: {
                    paddingBottom: '20px',
                },
                '& h2': {
                    textTransform: 'uppercase !important',
                    fontSize: '2rem',
                    fontFamily: 'BebasNeue',
                    textAlign: 'center',
                    margin: '0 0 0.5rem',
                },
            },
            '& .bgsProcessWrapper': {
                paddingBottom: '55px',
                [theme.breakpoints.down(minWidth?.small_medium_down)]: {
                    paddingBottom: '30px',
                },
                [theme.breakpoints.down(minWidth?.small_screen_up)]: {
                    borderBottom: '0',
                    paddingBottom: '10px',
                },
                '& .row': {
                    [theme.breakpoints.down(minWidth?.small_screen_up)]: {
                        marginLeft: '0',
                        marginRight: '0',
                    },
                },
                '& .processBlock': {
                    textAlign: 'center',
                    paddingRight: '15px',
                    paddingLeft: '15px',
                    [theme.breakpoints.up(minWidth?.small_screen_down)]: {
                        borderLeft: `1pt solid ${palette?.common?.gray_700}`,
                    },
                    '&:first-child': {
                        border: 'none',
                        [theme.breakpoints.down(minWidth?.small_screen_down)]: {
                            '& .processBlockInnerWrapper': {
                                paddingTop: '0px',
                            },
                        },
                    },
                    '&:last-child': {
                        paddingBottom: '0',
                        [theme.breakpoints.up(minWidth?.medium_screen_down)]: {
                            '& .textBlock': {
                                paddingLeft: '30px',
                                paddingRight: '30px',
                            },
                        },
                        '& .processBlockInnerWrapper': {
                            maxWidth: '290px',
                            letterSpacing: '-0.6px',
                        },
                    },
                    '& .imageContainer': {
                        marginBottom: '40px',
                        height: '75px',
                        [theme.breakpoints.down(minWidth?.small_medium_down)]: {
                            marginBottom: '30px',
                            height: '60px',
                        },
                        '& img': {
                            maxWidth: '75px',
                            [theme.breakpoints.down(minWidth?.small_medium_down)]: {
                                maxWidth: '60px',
                            },
                        },
                    },
                    '& .subheading': {
                        fontSize: typography.font_size_md,
                        textTransform: 'uppercase',
                        fontWeight: typography.font_weight_bold,
                    },
                    '& .textBlock': {
                        margin: '0 auto',
                        fontWeight: typography.font_weight_light,
                        fontFamily: typography.font_family_base,
                        marginTop: '15px',
                        fontSize: typography.font_size_md,
                        lineHeight: '1.5',
                        [theme.breakpoints.down(minWidth?.small_medium_down)]: {
                            fontSize: typography.font_size_base,
                            lineHeight: '1.5',
                        },
                    },
                    '& .processBlockInnerWrapper': {
                        maxWidth: '240px',
                        margin: '0 auto',
                        paddingTop: '20px',
                        paddingBottom: '20px',
                        [theme.breakpoints.down(minWidth?.small_screen_up)]: {
                            borderBottom: `1pt solid ${palette?.common.gray_700}`,
                            maxWidth: '290px',
                            paddingBottom: '30px',
                            paddingTop: '30px',
                        },
                    },
                },
            },
            '& .reviewsSection': {
                display: 'flex',
                paddingTop: '0 !important',
                paddingBottom: '1.5rem !important',
                flexWrap: 'wrap',
                marginRight: '-15px',
                marginLeft: '-15px',
                justifyContent: 'center',
                '& .reviewsTitle': {
                    paddingBottom: '1rem !important',
                    '& .title': {
                        textTransform: 'uppercase',
                        textAlign: 'center',
                        fontFamily: 'BebasNeue',
                    },
                },
                '& h2': {
                    marginBottom: '0.5rem',
                    fontWeight: 500,
                    lineHeight: '1.2',
                    fontSize: '2rem',
                },
                '& img': {
                    maxWidth: '100%',
                },
            },
        },
    };
};

export default styles;
